import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import { SupportMessage } from 'Context/Support';

import classes from './conversationChat.module.css';

function formatTimestamp(dateStr: string): string {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

interface Props {
  message: SupportMessage;
}

function MessageBubble({ message }: Props) {
  const { body, is_from_support, created_at } = message;
  const isUser = !is_from_support;

  return (
    <div className={`${classes.bubbleRow} ${isUser ? classes.bubbleRowUser : classes.bubbleRowSupport}`}>
      <div>
        <div className={`${classes.bubble} ${isUser ? classes.bubbleUser : classes.bubbleSupport}`}>{body}</div>
        <div className={`${classes.bubbleTime} ${isUser ? classes.bubbleTimeUser : ''}`}>
          {formatTimestamp(created_at)}
        </div>
      </div>
    </div>
  );
}

const MessageBubbleMemo = memo(MessageBubble, areEqual);

export { MessageBubbleMemo as MessageBubble };
